<template>
  <Layout
    class="forbidden"
    heading="ERROR"
    sub-heading="本機能をご利用いただく権限がございません"
  >
    <template #symbolMark>
      <div
        class="forbidden__symbolMark"
        :style="{
          backgroundImage: `url(${require('@/assets/images/Pages/Error/Forbidden/symbolMark.svg')})`
        }"
      />
    </template>
  </Layout>
</template>

<script>
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Layout from "../Molecules/Layout/index.vue";

import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ErrorForbidden",
  components: {
    Heading,
    Layout
  },
  setup() {
    return {};
  }
});
</script>

<style scoped lang="scss">
.forbidden {
  &__symbolMark {
    position: absolute;
    top: 50%;
    left: 105px;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    transform: translateY(-50%);
    width: 228px;
    height: 173px;
  }
  &__description {
    color: $grayscale50;
  }
  &::v-deep {
    .layout {
      &__heading {
        font-size: 120px;
        line-height: 173px;
      }
    }
  }
}
</style>
